export const initialState = () => ({
  menuOption: "Início",
  subMenuOption: "",
  notificationBellAmount: 0,
  lastTotalNotificationCount: 0,
  currentTotalNotificationCount: 0,
  updatedRoute: false
})
